import React, { useEffect, useState } from 'react';
import MuiTable from '../../components/MuiTable/MuiTable';
import Button from '../../components/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import PageHeading from '../../components/PageHeading/PageHeading';
import InputForm from '../../components/InputForm/InputForm';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import instance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import Input from '../../components/Input/Input';
import { useNavigate } from 'react-router-dom';
import { StateProps } from '../../redux/reducer';
import { errorMessage } from '../../config/errorsMsg';
import { successMessage } from '../../config/keyword';

interface AddRolesProps {
  name: string;
  id: string;
}

type ResultProps = {
  id: string;
};

type Roleresponse = {
  role: string;
  organization: string;
  organizationId: string;
  id: string;
};
const columns = [
  {
    id: 'role',
    label: 'Role',
    minWidth: 70,
    align: 'left',
  },

  {
    id: 'action',
    label: 'Action',
    minWidth: 0,
    align: 'right',
  },
];

const Roles = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const [roleState, setRoleState] = useState<AddRolesProps>({
    name: '',
    id: '',
  });
  const { name } = roleState;
  const [isSubmit, setIsSubmit] = useState(false);
  const [formError, setFormError] = useState<any>({});
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [roles, setRoles] = useState([
    {
      id: '',
      role: '',
    },
  ]);

  useEffect(() => {
    const breadcrumb = [{ path: '/roles', name: 'Role' }];
    dispatch(update_breadcrumb(breadcrumb));
    getAllRoles();
  }, []);

  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      addRoles();
    }
  }, [formError]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRoleState({
      ...roleState,
      [event.target.name]: event.target.value,
    });
    if (event.target.value !== '') {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: `Rolename is required  `,
      });
    }
  };

  const gotResponse = (data: Roleresponse[]) => {
    setRoles(data);
    dispatch(updateIsLoading(false));
  };

  const onSubmit = () => {
    setFormError(validation());
    setIsSubmit(true);
  };

  const validation = () => {
    const error: any = {};
    if (!name) {
      error.name = errorMessage.emptyOrgRole;
    } else if ((name.length > 0 && name.length < 2) || name.length > 128) {
      error.name = errorMessage.orgRoleNameLength;
    }
    return error;
  };

  const addRoles = () => {
    const obj = {
      name: name,
    };
    dispatch(updateIsLoading(true));
    instance
      .post(`/organizations/${userInfo.organizationId}/roles`, obj)
      .then((response) => {
        if (response.status === 201) {
          const obj = {
            isOpen: true,
            message: successMessage.ROLE_ADD,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          setIsFormOpen(false);
          getAllRoles();
          setRoleState({
            ...roleState,
            name: '',
          });
          navigate(`/roleDetails/${response.data.id}`);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  //Get all Roles
  const getAllRoles = () => {
    dispatch(updateIsLoading(true));
    instance
      .get(`/organizations/${userInfo.organizationId}/roles`)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const viewRecord = (row: ResultProps) => {
    navigate(`/roleDetails/${row.id}`);
  };

  const onCancel = () => {
    setIsFormOpen(false);
    setIsSubmit(false);
    setFormError({});
    setRoleState({
      ...roleState,
      name: '',
    });
  };

  return (
    <>
      <div className="p-2 w-full">
        <div className="flex items-center justify-between">
          <div className="w-full">
            <PageHeading label="Roles Management" />
          </div>
        </div>
        <div className="bg-white rounded-sm">
          <div className="px-2 pt-2 flex justify-end">
            <Button
              label="Add"
              type="button"
              buttonType="primary"
              icon={<i className="fa-solid fa-plus"></i>}
              onClick={() => setIsFormOpen(!isFormOpen)}
            />
          </div>

          <div className="bg-white">
            <InputForm
              title={'Add New Role'}
              isFormOpen={isFormOpen}
              onSubmit={onSubmit}
              onCancel={() => onCancel()}
            >
              <Input
                name={'name'}
                type={'text'}
                label={'Role Name'}
                value={name}
                placeholder={`Enter Role Name`}
                onChange={handleChange}
                error={formError?.name}
              />
            </InputForm>
          </div>

          <div className="p-2">
            <MuiTable
              columns={columns}
              rows={roles}
              onViewHandler={viewRecord}
              checkBoxShow={false}
              checkBoxValue={'titleCode'}
              showView={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Roles;
